<div class="modal-header">
  <h3 class="modal-title">{{ titelModal }}</h3>
  <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body scroll-dark-active activity">
  <form [formGroup]="activitiesForm" (ngSubmit)="add()">
    <input type="hidden" formControlName="id" value={{activities.id}}>
    <div class="form-group">
      <h4 class="form-section "><i class="fas fa-user-tag ml-1"></i> Actividad</h4>
    </div>
    <div class="form-group">
      <label class="text-form">Asunto
        @if (activitiesForm.controls['subject'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <input type="text" class="form-control style-asunto" formControlName="subject" value={{activities.subject}}
        [ngClass]="{ 'is-invalid':activitiesForm.controls['subject'].errors && activitiesForm.controls.subject.touched}">
      @if (activitiesForm.controls['subject'].errors && activitiesForm.controls.subject.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @for (validation of activities_validation_messages.subject; track validation) {
            <div>
              @if (activitiesForm.get('subject').hasError(validation.type) ) {
                <div class="error-message">
                  {{validation.message}}
                </div>
              }
            </div>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label for="" class="text-form">Texto
      </label>
      <textarea class="form-control style-textarea" formControlName="content" value={{activities.content}} rows="3"
        cols="40"
      [ngClass]="{ 'is-invalid':activitiesForm.controls.content.errors  && activitiesForm.controls.content.touched}"></textarea>
      @if (activitiesForm.controls.content.errors  && activitiesForm.controls.content.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @for (validation of activities_validation_messages.content; track validation) {
            <div>
              @if (activitiesForm.get('content').hasError(validation.type) ) {
                <div class="error-message">
                  {{validation.message}}
                </div>
              }
            </div>
          }
        </small>
      }
    </div>
    <!-- Fecha y Hora -->
    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <label for="" class="text-form">Fecha:
            @if (activitiesForm.controls['date_activity'].errors?.required) {
              <span class="text-danger">&#10033;</span>
            }
          </label>
        </div>
        <div class="col-md-6">
          <label for="" class="text-form">Hora:
            @if (activitiesForm.controls['hour_activity'].errors?.required) {
              <span class="text-danger">&#10033;</span>
            }
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input type="hidden" formControlName="date_activity">
          <div class="input-group">
            <input class="form-control style-datepicker" placeholder="Seleccionar fecha" name="Fecha_Actividad"
              [(ngModel)]="model1" #Fecha_Actividad="ngModel" [ngModelOptions]="{standalone: true}" ngbDatepicker
              #d1="ngbDatepicker" [minDate]="mindate" [readonly]="true" [placement]="'bottom-left'"
              [ngClass]="{ 'is-invalid': activitiesForm.controls.date_activity.errors && activitiesForm.controls.date_activity.touched}"
              (ngModelChange)="change($event)">
            <div class="input-group-append style-button">
              <button class="btn fas fa-calendar-alt bt" (click)="d1.toggle()" type="button"></button>
            </div>
          </div>
          @if (activitiesForm.controls.date_activity.errors && activitiesForm.controls.date_activity.touched) {
            <small class="form-text text-muted text-danger"
              >
              @for (validation of activities_validation_messages.date_activity; track validation) {
                <div>
                  @if (activitiesForm.get('date_activity').hasError(validation.type)) {
                    <div class="error-message">
                      {{validation.message}}
                    </div>
                  }
                </div>
              }
            </small>
          }
        </div>
        <div class="col-md-6">
          <input type="hidden" formControlName="hour_activity">
          <input
            type="time"
            class="form-control time-input-activity"
            [(ngModel)]="activityTimeString"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onActivityTimeChange($event)"
            [ngClass]="{ 'is-invalid': activitiesForm.controls.hour_activity.errors && activitiesForm.controls.hour_activity.touched}"
          >
          @if (activitiesForm.controls.hour_activity.errors && activitiesForm.controls.hour_activity.touched) {
            <small class="form-text text-muted text-danger"
              >
              @for (validation of activities_validation_messages.hour_activity; track validation) {
                <div>
                  @if (activitiesForm.get('hour_activity').hasError(validation.type)) {
                    <div class="error-message">
                      {{validation.message}}
                    </div>
                  }
                </div>
              }
            </small>
          }
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="text-form">Colaboradores</label>
      <ng-select formControlName="idsCollaborators" [items]="collaborators" bindLabel="text" bindValue="id" [multiple]="true"
        placeholder="Seleccione colaboradores"
        class="form-control px-0 py-0 collaborators"
        [ngClass]="{ 'is-invalid': activitiesForm.controls.idsCollaborators.errors && activitiesForm.controls.idsCollaborators.touched }">
      </ng-select>
      @if (activitiesForm.controls.idsCollaborators.errors && activitiesForm.controls.idsCollaborators.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @for (validation of activities_validation_messages.idsCollaborators; track validation) {
            <div>
              @if (activitiesForm.get('idsCollaborators').hasError(validation.type) ) {
                <div class="error-message">
                  {{validation.message}}
                </div>
              }
            </div>
          }
        </small>
      }
    </div>
    <!-- Message Success Activity -->
    @if (successMessageActivity) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert class="mt-3" type="success" (close)="successMessageActivity = ''">{{ successMessageActivity
            }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    <!-- Message Error Activity -->
    @if (errorMessageActivity) {
      <div class="form-group">
        <div class="row">
          <div class="col-md-12">
            <ngb-alert class="mt-3" type="danger" (close)="errorMessageActivity = ''">{{ errorMessageActivity
            }}</ngb-alert>
          </div>
        </div>
      </div>
    }
    <div class="line_horizontal_container">
      <div class="line_horizontal"></div>
    </div>
    <div class="col-md-12">
      <div class="row" formArrayName="alerts">
        <div class="col-4 pr-0">
          <h4 class="form-section "><i class="far fa-bell ml-1"></i> Alertas</h4>
        </div>
        <div class="col-8 pl-0">
          <div class="form-group overflow-hidden">
            <button class="btn btn-primary mb-1" (click)="addRepeat($event.preventDefault())">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
        @for (repeatForm of listAlerts.controls; track repeatForm; let i = $index) {
          <div class="col-12">
            <div class="row activity-alerts" [formGroupName]="i">
              <div class="col-md-5 date-activity">
                <label for="" class="text-form mb-1">Fecha:</label>
                <div class="input-group">
                  <input type="hidden" formControlName="id" value={{repeatForm.value.id}}>
                  <input type="hidden" formControlName="date_before_activity">
                  <input class="form-control style-datepicker" placeholder="Seleccionar fecha" name="Fecha_Alert"
                    [(ngModel)]="model2[i]" #Fecha_Alert="ngModel" [ngModelOptions]="{standalone: true}" ngbDatepicker
                    #d2="ngbDatepicker" [minDate]="mindate" [maxDate]="maxdate" [readonly]="true"
                    [placement]="'bottom-left'">
                  <div class="input-group-append style-button">
                    <button class="btn fas fa-calendar-alt bt" (click)="d2.toggle()" type="button"></button>
                  </div>
                </div>
              </div>
              <div class="col-md-5 pr-0">
                <label for="" class="text-form mb-1">Hora:</label>
                <input type="hidden" formControlName="hour_before_activity">
                <input
                  type="time"
                  class="form-control time-input-alert"
                  [(ngModel)]="timeAlertStrings[i]"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onAlertTimeChange(i, $event)"
                  >
              </div>
              <div class="col-md-2 check d-flex align-items-end justify-content-center pb-0">
                <button type="button" class="btn btn-danger" (click)="removeRepeat(i)">
                  <i class="fas fa-minus mr-0"></i>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="form-group mt-3">
      <div class="row">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
            (click)="activeModal.close('Close click')">
            Cerrar
          </button>
          <button type="submit" class="btn btn-outline-primary  rounded-pill font-weight-bold mr-2"
            style="width: 120px;" [disabled]="!submitted  && activitiesForm.invalid">
            @if (submitted && activitiesForm.valid) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Cargando...
              </div>
            }
            @if (!submitted) {
              <span>
                {{ edicion ? 'Guardar':'Crear' }}
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
